export default __webpack_public_path__ + "static/notosans-bold-webfont-7ae13341ef1c03b98e8f02909cbccca6.woff2";